import React from 'react';
//import ProductsPage from '../../Components/ProductsPage/ProductsPage';
import CategoriasPage from '../../Components/ProductsPage/CategoriasPage';
import { Link as Anchor, } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, } from '@fortawesome/free-solid-svg-icons';
import '../../css/Pages/PageProducts/PageProducts.css';
import HeaderBack from '../../Components/HeaderBack/HeaderBack';
export default function PageProductos() {


    return (
        <div>
            <div style={{
                backgroundImage: '',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                height: '18vh',


            }} className='bgPage'>
                <HeaderBack title='' />
                <Anchor to={`/`}>
                    <FontAwesomeIcon icon={faHome} /> Inicio
                </Anchor>
                |
                <Anchor to=''>
                    Filtros por Categorías
                </Anchor>
            </div>

            <CategoriasPage />
        </div>
    );
}
